import styled from '@emotion/styled';
import { InputBase, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const Container = styled.div(() => ({
  gap: 8,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const Label = styled.div((props) => ({
  marginTop: 8,
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const StyledTimeInput = styled(InputBase)((props) => ({
  width: 40,
  height: 30,
  fontSize: 14,
  fontWeight: 500,
  textAlign: 'center',
  borderRadius: 5,
  backgroundColor: props.theme.colors.lightBlue,
  color: props.theme.colors.text.primary,
  fontFamily: props.theme.fonts.primary,
  input: {
    textAlign: 'center',
    padding: 0,
    border: 'none',
    outline: 'none',
    borderRadius: 5,
  },
  '& input:focus': {
    border: `1px solid ${props.theme.colors.accent}`,
  },
}));

export const TimeColon = styled('span')((props) => ({
  fontSize: 18,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.text.primary,
  lineHeight: '30px',
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  height: 30,
  borderRadius: 5,
});

export const StyledToggleButton = styled(ToggleButton)((props) => ({
  flex: 1,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.inactive,
  '&.Mui-selected': {
    backgroundColor: props.theme.colors.lightBlue,
    color: props.theme.colors.secondary,
  },
  '&:not(:last-of-type)': {
    borderRight: '1px solid #ccc',
  },
}));
